export var STORAGE_NAME = 'auth';
export var initialState = {
    isAuthenticated: false,
    isInitialized: false,
    loginError: false,
    accessToken: undefined,
    refreshToken: undefined,
    photoURL: undefined,
    displayName: undefined,
    role: undefined,
    id: undefined,
    email: undefined,
    showInterfaceSettings: undefined,
    // ensure a valid default currency value to avoid extra null checks
    mainCurrency: 'RUB',
    permissions: [],
    sessions: [],
    loginHistory: []
};
export var cache = {
    accessToken: 0,
    refreshToken: 0
};
